import { memo, useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Local files
import { StyledListItem } from './Item.styled';
import StudyTaskDialog from 'components/Dialogs/StudyTask/StudyTask';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Item = ({ id, input, status, updated_at }) => { 
  const [studyTaskDialog, setStudyTaskDialog] = useState({ open: false, taskId: '' });
  const date = new Date(updated_at).toLocaleDateString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  
  const handleCreate = () => setStudyTaskDialog({ open: true, taskId: id });
  const handleClose = () => setStudyTaskDialog({ open: false, taskId: '' });

  return (
    <>
      <StudyTaskDialog {...studyTaskDialog} onClose={handleClose} />
      <StyledListItem disablePadding>
        <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Typography noWrap>{input}</Typography>
          <Typography variant='subtitle2' noWrap>Status: {status}</Typography>
          <Typography variant='subtitle2' noWrap>{date}</Typography>
        </Box>
        <Button variant='contained' onClick={handleCreate} sx={{ mr: 1 }}>View</Button>
      </StyledListItem>
    </>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);